import React from "react";
import Navbar from "./Navbar";
import SearchList from "./searchlist";
import Footer from "./Footer";
const SearchResults = () => {
  return (
    <>
      <Navbar />
      <SearchList/>
      <Footer />
    </>
  );
};

export default SearchResults;
